import { generatePath, useMatch } from "react-router";
import useClientContext from "../../context/useClientContext";
import { pageRoutes } from "../../routes";
import MenuLinkItem from "../common/MenuLinkItem";
import SubMenuList from "./SubMenuList";

const FundAdminWorkflowsMenu = () => {
  const { clientCode } = useClientContext();

  const routePattern = `/:clientCode/${pageRoutes.workflows}/:page/*`;

  const routeMatch = useMatch(routePattern);
  const currentPage = routeMatch?.params["page"];

  const buildFullPath = (page: string) => generatePath(routePattern, { clientCode, page });

  return (
    <SubMenuList>
      <MenuLinkItem
        subItem
        active={currentPage === pageRoutes.checklists}
        title="Checklists"
        href={buildFullPath(pageRoutes.checklists)}
      />
    </SubMenuList>
  );
};

export default FundAdminWorkflowsMenu;
